<template>
  <div class="footer">
    <div class="footerMenu">
      <div class="menuContainer">
        <div class="menu">
          <div class="pointer" v-for="(item, index) in footerList1" :key="index" @click="goto(item.href)">{{item.label}}</div>
        </div>
        <div class="menu">
          <div class="pointer" v-for="(item, index) in footerList2" :key="index" @click="goto(item.href)">{{item.label}}</div>
        </div>
      </div>
      <div class="download">
        <div>
          <img class="logo" :src="logo" alt="">
          <img class="pointer" :src="andDownload" alt="" @click="popup()">
        </div>
      </div>
    </div>
    <img :src="payment" alt="" class="payment">
    <div class="copyRight" v-html="$t('lang.copyRight')+'<br>'"></div>
    <div class="CuracaoSymbol">
      <div style="position:relative;width:120px;">
      </div>
    </div>
    <DownAppPopup v-if="$store.state.showPopupDownApp"/>
  </div>
</template>

<script>
import logo from '@/assets/images/common/logo3.svg'
import andDownload from '@/assets/images/common/andDownload.png'
import payment from '@/assets/images/common/payment_logo.png'
import {mapMutations} from 'vuex'
import DownAppPopup from '@/pages/Message/DownApp'
export default {
  name: 'Footer',
  data () {
    return {
      logo,
      andDownload,
      payment,
      footerList1: [
        {
          label: this.$t('lang.label.casino'),
          href: 'Games?type=LiveCasino' // changed to LiveCasino from casino by HHY 20220527
        },
        // {
        //   label: this.$t('lang.label.slots'),
        //   href: 'Games?type=SlotGames' // changed to SlotGames from slots by HHY 20220527
        // },

        {
          label: this.$t('lang.menu.Promotion'),
          href: 'Promotion'
        },
        {
          label: this.$t('lang.menu.FAQ'),
          href: 'FAQ'
        },
        {
          label: this.$t('lang.menu.AboutUs'),
          href: 'Documents/About'
        },
        {
          label: this.$t('lang.menu.Support'),
          href: 'Support'
        }
      ],
      footerList2: [
        {
          label: this.$t('lang.menu.Terms'),
          href: 'Documents/Terms'
        },
        {
          label: this.$t('lang.menu.Privacy'),
          href: 'Documents/Privacy'
        },
        {
          label: this.$t('lang.menu.Kyc'),
          href: 'Documents/Kyc'
        },
        {
          label: this.$t('lang.menu.Responsible'),
          href: 'Documents/Responsible'
        },
        {
          label: this.$t('lang.menu.News'),
          href: 'Documents/News'
        }
      ]
    }
  },
  components: {
    DownAppPopup
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute'
    }),
    goto (path) {
      if (this.$store.state.currentRoute === path) return
      if (path === 'Support') {
        window.LiveChatWidget.call('maximize')
        return
      }
      this.setCurrentRoute(path)
      this.$router.push('/' + path)
    },
    popup () {
      this.$store.state.showPopupDownApp = true
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  padding-top: 60px;
  text-align: center;
  .footerMenu {
    padding-left: 217px;
    padding-right: 134px;
    margin-bottom: 60px;
    text-align: left;
    display: flex;
    justify-content: space-between;
    .menuContainer {
      display: flex;
      .menu {
        margin-right: 130px;
        div {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
          margin-bottom: 30px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        &:nth-child(2) {
          margin-right: 0;
        }
      }
    }
    .download {
      >div {
        display: flex;
        align-items: center;
        .logo {
          width: 107px;
          margin-right: 27px;
        }
        .label {
          width: 200px;
          font-size: 24px;
          line-height: 28px;
          color: #F6D9AA;
        }
      }
    }
  }
  .payment {
    height: 105px;
    margin-bottom: 40px;
  }
  .copyRight {
    margin: 42px auto 0 auto;
    width: 95vw;
    padding-bottom: 25px;
    font-size: 12px;
    color: #F6D9AA;
  }
  .CuracaoSymbol {
    width: 100%;
    display: flex;
    justify-content:center;
    margin-bottom: 55px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue